import ViewTable from "modules/DeclareLeave/components/CustomTable";

import { Box, Button, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

import { useDispatch, useSelector } from "react-redux";
import {
  selectListArriveLateManager,
  selectListReasonArriveLate,
} from "modules/DeclareLeave/redux/selector";
import { useDialog, useLegacyEffect } from "helper/customHook";
import {
  ApproveStatus,
  ApproveStatusValue,
  statusColor,
} from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";
import { DIALOG } from "helper/enum/dialogEnum";
import EmptyState from "components/common/EmptyState";
import { PopupConfirm } from "./PopupConfirm";
import { setupDataRequest } from "modules/DeclareLeave/redux/handleRequest";
import ArriveLateManagerDetails from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/ArriveLateManagerDetail";
import { getReasonArriveLateStart } from "modules/DeclareLeave/redux/getReasonArriveLate";
import { useNavigate, useParams } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { formatDateStringToDDMMYYYY } from "helper/utils";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import { memo } from "react";

export const ListArriveLate = memo(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const approveDialog = useDialog(DIALOG.APPROVE_REQUEST_POPUP);
  const data = useSelector(selectListArriveLateManager);
  const listReasonArriveLate = useSelector(selectListReasonArriveLate);
  const requestLeaveDialog = useDialog(
    DIALOG.MANAGER_VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL
  );
  const columns = [
    {
      id: "registerDate",
      accessorKey: "registerDate",
      header: "Ngày tạo đơn",
      footer: (props) => props.column.id,
      minSize: 120,
      pinPosition: "left",
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {formatDateStringToDDMMYYYY(info.getValue())}
        </Typography>
      ),
    },
    {
      id: "employeeName",
      accessorKey: "employeeName",
      header: "Tên nhân viên",
      minSize: 115,
      pinPosition: "left",
    },
    {
      id: "positionName",
      accessorKey: "positionName",
      header: "Chức danh",
      minSize: 110,
      pinPosition: "left",
    },
    {
      id: "departmentName",
      accessorKey: "departmentName",
      header: "Đơn vị",
      footer: (props) => props.column.id,
      minSize: 110,
      pinPosition: "left",
    },
    {
      id: "type",
      accessorKey: "type",
      header: "Loại",

      cell: (info) => {
        const listType = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-end"}
            width={"100%"}
          >
            {listType.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {type}
              </Typography>
            ))}
          </Box>
        );
      },
      footer: (props) => props.column.id,
      minSize: 120,
      enablePinning: true,
    },
    {
      accessorKey: "dayOffs",
      header: () => "Ngày đi muộn/về sớm",
      footer: (props) => props.column.id,
      cell: (info) => {
        const dayOffs = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-end"}
            width={"100%"}
          >
            {dayOffs.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {type}
              </Typography>
            ))}
          </Box>
        );
      },
      minSize: 250,
    },
    {
      accessorKey: "totalMinutes",
      header: () => <span>Số phút</span>,
      footer: (props) => props.column.id,
      minSize: 80,
    },
    {
      accessorKey: "reason",
      header: "Lý do đi muộn/về sớm",
      cell: (info) => {
        const reasons = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-end"}
            width={"100%"}
          >
            {reasons.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {listReasonArriveLate.find((i) => i.value === type)?.label}
              </Typography>
            ))}
          </Box>
        );
      },
      footer: (props) => props.column.id,
      minSize: 180,
    },
    {
      id: "modifiedDate",
      accessorKey: "modifiedDate",
      header: "Ngày cập nhật đơn",
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {info.getValue() ? formatDateStringToDDMMYYYY(info.getValue()) : ""}
        </Typography>
      ),
      footer: (props) => props.column.id,
      minSize: 155,
      pinPosition: "left",
    },

    {
      accessorKey: "note",
      header: "Lý do chi tiết",
      minSize: 100,
    },
    {
      accessorKey: "refuseReason",
      header: "Lý do phê duyệt",
      footer: (props) => props.column.id,
      minSize: 150,
    },
    {
      accessorKey: "status",
      header: "Trạng thái",
      footer: (props) => props.column.id,
      cell: (info) => {
        const status = info.getValue();
        return (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              fontWeight: 600,
              color: statusColor(theme, status, "color"),
              textAlign: "right",
            })}
            width={"100%"}
          >
            {ApproveStatus[status]}
          </Typography>
        );
      },
      minSize: 100,
    },
    {
      accessorKey: "action",
      header: "",
      cell: (info) => (
        <Box
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
          gap={1}
          sx={{
            marginLeft: `-${pxToRem(15)}`,
            marginRight: `-${pxToRem(18)}`,
            height: "100%",
            width: `calc(100% + ${pxToRem(32)})`,
            backgroundColor: "white",
            paddingY: 2,
          }}
        >
          {info.row.original.status === ApproveStatusValue.PENDING && (
            <>
              <Button
                onClick={(e) => handleApprove(e, true, info.row.original.id)}
                color="success"
                sx={{ padding: `${pxToRem(4)} ${pxToRem(10)}`, fontSize: 12 }}
              >
                Duyệt
              </Button>
              <Button
                onClick={(e) => handleApprove(e, false, info.row.original.id)}
                sx={{ padding: `${pxToRem(4)} ${pxToRem(10)}`, fontSize: 12 }}
                color="error"
              >
                Từ chối
              </Button>
            </>
          )}
        </Box>
      ),

      minSize: 100,
    },
  ];

  const handleApprove = (e, isApprove: boolean, id: string) => {
    dispatch(setupDataRequest({ isApprove, id }));

    e.stopPropagation();
    approveDialog.open();
  };

  useLegacyEffect(() => {
    if (listReasonArriveLate.length === 0) {
      dispatch(getReasonArriveLateStart());
    }
  }, []);

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      requestLeaveDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.orderManagement}/${declareLeaveURL.lackOfTime}/${idRecord}`,
        { replace: true }
      );
    }
  };

  return (
    <>
      <ViewTable
        data={data ?? []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {}}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn xin đi muộn/về sớm nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => {
          handleViewDetail(item.id);
        }}
        height={"auto"}
      />
      <ArriveLateManagerDetails />
      <PopupConfirm />
    </>
  );
});
